import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { Schema } from 'yup';
import { ETIFormData } from '../types';

const questionShape: Schema = yup.object().shape({
  section: yup.string().required('Section is required'),
  question: yup.string().required('Question is required'),
  questionType: yup
    .string()
    .oneOf(
      ['text', 'optional_text', 'radio', 'checkbox', 'attachment'],
      'Type is invalid',
    )
    .required('Type is required'),
  optionsRaw: yup
    .string()
    .test(
      'valid-options-raw',
      'Options must be a JSON array of strings',
      function (value: any) {
        const { questionType } = this.parent as any;
        if (!(questionType === 'radio' || questionType === 'checkbox'))
          return true;
        if (!value) return false;
        try {
          const parsed = JSON.parse(value);
          return (
            Array.isArray(parsed) &&
            parsed.every((v: any) => typeof v === 'string')
          );
        } catch (_) {
          return false;
        }
      },
    ),
  filterRaw: yup
    .string()
    .test('valid-filter-raw', 'Invalid filter format', (value: any) => {
      if (!value) return true;
      try {
        const parsed = JSON.parse(value);
        if (!parsed || typeof parsed !== 'object') return false;
        return Object.values(parsed).every(
          (v: any) =>
            typeof v === 'string' ||
            (Array.isArray(v) && v.every((i: any) => typeof i === 'string')),
        );
      } catch (err) {
        console.error(err);
        return false;
      }
    }),
});

const sectionMetadataShape: Schema = yup.object().shape({
  sectionName: yup.string().required('Section name is required'),
  description: yup.string().required('Description is required'),
});

const getSchema = () => {
  return yup.object().shape({
    questions: yup.array().of(questionShape).required().min(1),
    sectionMetadata: yup.array().of(sectionMetadataShape).optional(),
  });
};

const useETIForm = () => {
  const { control, handleSubmit, reset, formState, getValues, setValue } =
    useForm<Omit<ETIFormData, 'taskId' | 'status'>>({
      resolver: yupResolver(getSchema()),
      mode: 'onChange',
      reValidateMode: 'onChange',
    });

  return {
    control,
    handleSubmit,
    reset,
    isValid: formState.isValid,
    isDirty: formState.isDirty,
    getValues,
    setValue,
  };
};

export default useETIForm;
